/**
 * Column registry for the import-batch log detail view.
 *
 * The table is driven by per-entity column descriptors so that, when logs for
 * other entities (orders, purchases, ...) start being produced, only this file
 * needs a new entry -- the view renders whatever columns it is given.
 *
 * Descriptor shape:
 *   - key:       unique identifier for the column (also the v-for key)
 *   - titleKey:  i18n key for the header label
 *   - path:      dotted path used to read the value from a log item
 *   - sortField: server-side sort field; when omitted the column is not sortable
 *                (must be one of the backend's allowed sort fields)
 *   - type:      how the cell is rendered ('text' | 'logType' | 'json')
 */

// Shared columns present for every entity type.
const BASE_COLUMNS = [
  { key: "row_index", titleKey: "key_log_theader_row", path: "row_index", sortField: "row_index", type: "text" },
  { key: "log_type", titleKey: "key_log_theader_type", path: "log_type", sortField: "log_type", type: "logType" },
  { key: "message", titleKey: "key_log_theader_message", path: "message", type: "text" },
];

// Metadata columns specific to each entity type, appended after the base ones.
const ENTITY_METADATA_COLUMNS = {
  products: [
    { key: "ean", titleKey: "key_log_theader_ean", path: "metadata.ean", type: "text" },
    { key: "name", titleKey: "key_log_theader_product", path: "metadata.name", type: "text" },
  ],
};

// Fallback for entity types without a specific mapping: show raw metadata.
const DEFAULT_METADATA_COLUMNS = [
  { key: "metadata", titleKey: "key_log_theader_metadata", path: "metadata", type: "json" },
];

export function getLogColumns(entityType) {
  const metadataColumns = ENTITY_METADATA_COLUMNS[entityType] || DEFAULT_METADATA_COLUMNS;
  return [...BASE_COLUMNS, ...metadataColumns];
}

/** Null-safe read of a dotted path from a log item. */
export function resolveLogValue(item, path) {
  return path.split(".").reduce((value, key) => (value == null ? value : value[key]), item);
}
